import type { RouteObject } from "react-router";
import { CANCEL_PAGE_PATH, RETURN_PAGE_PATH } from "@worker/page-paths";
import { AboutPage } from "@/routes/about-page";
import { CancelPage } from "@/routes/cancel-page";
import { NotFoundPage } from "@/routes/not-found-page";
import { ReturnPage } from "@/routes/return-page";

/**
 * The app's routes as data, so a test can match a URL against exactly what
 * App renders (./route-table.test.ts).
 *
 * `/return` and `/cancel` are not this file's to name: Stripe holds them from
 * the `success_url`/`cancel_url` the Worker wrote (@worker/page-paths), so
 * they are imported from there. A page that moves without the Worker moving
 * with it is a paid shopper reading "nothing has been charged" on the
 * not-found page.
 */
export const appRoutes: RouteObject[] = [
  { path: "/", element: <AboutPage /> },
  { path: RETURN_PAGE_PATH, element: <ReturnPage /> },
  { path: CANCEL_PAGE_PATH, element: <CancelPage /> },
  { path: "*", element: <NotFoundPage /> },
];
